export default interface IPatientValidationError {
	givenNameError: string;
	familyNameError: string;
	yearOfBirthError: string;
	monthOfBirthError: string;
	dateOfBirthError: string;
	mobileError: string;
	notesError: string;
	attendancePreferenceError: string;
	mobileFormatError: string;
	isTelehealthError: string;
	sexError: string;
}

export const InitialPatientValidationErrorState: IPatientValidationError = {
	givenNameError: "",
	familyNameError: "",
	yearOfBirthError: "",
	monthOfBirthError: "",
	dateOfBirthError: "",
	mobileError: "",
	notesError: "",
	attendancePreferenceError: "",
	mobileFormatError: "",
	isTelehealthError: "",
	sexError: "",
};
